<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <b-card>
            <form-wizard 
                title=""
                subtitle=""
                color="#007bff"
            >
                <template slot="step" slot-scope="props">
                    <wizard-step :tab="props.tab"
                    :transition="props.transition"
                    :key="props.tab.title"
                    :index="props.index">
                    </wizard-step>
                </template>

               
                <template slot="footer" slot-scope="props">
                    <div class="wizard-footer-left">
                        <wizard-button  v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.prevTab()" :style="props.fillButtonStyle"> {{ $t('customer.wizzard.prev') }} </wizard-button>
                    </div>
                    <div class="wizard-footer-right">
                        <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle"> {{ $t('customer.wizzard.next') }} </wizard-button>
                        <wizard-button v-else @click.native="onComplete(props.isLastStep)" class="wizard-footer-right finish-button" :style="props.fillButtonStyle">  {{props.isLastStep ? $t('customer.wizzard.complete') : $t('customer.wizzard.next')}}</wizard-button>
                    </div>
                </template>
                <tab-content :title="$t('dealer.wizzard.stepName1')" icon="ti-id-badge" class="formGroup" :before-change="() => changeStep(0,1)">
                    <Form ref="GeneralForm" :loading="loading" :forms="GeneralForms" />
                </tab-content>
                <tab-content :title="$t('dealer.wizzard.stepName2')" icon="ti-direction-alt" class="formGroup"  :before-change="() => changeStep(1,2)">
                     <div class="actions">
                        <b-button variant="success"  @click="openModal(true,'add',{})"> <b-icon icon="plus" /> {{$t('general.add')}} </b-button>
                    </div> 
                    <Addresses ref="Address" :modalType="pageSettings" :modalEvent="openModal" />
                </tab-content>
                <tab-content :title="$t('dealer.wizzard.stepName3')" icon="ti-user"  :before-change="() => changeStep(2,3)">
                     <div class="actions">
                        <b-button variant="success"  @click="openModal(true,'add',{})"> <b-icon icon="plus" /> {{$t('general.add')}} </b-button>
                    </div>
                   <Users ref="Users" :modalType="pageSettings" :modalEvent="openModal"/>
                </tab-content>
                
            </form-wizard>
        </b-card>
         <!-- Modals -->
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import i18n from '@/plugins/i18n';
    import GeneralForm from './components/GeneralForm'
    import Users from './components/Users'
    import Addresses from './components/Addresses'
    import Form from '@/components/Form'
    import Forms from './forms'
    import {prepareRequestData, setFormData} from '@/assets/js/custom.js'
    import Modals from "./modals/"

    let breadCrumb = [
        { label: i18n.t('pages.dealer.name'), url: "/Dealer" },
        { label: i18n.t('pages.dealer.addNew'), url: "/Dealer/Add" },
    ]
    export default {
        name: 'DealerAdd',
        data: function(){
            return{
                breadCrumb,
                GeneralForms: Forms.GeneralForms,
                modalOpen: false,
                modalProps: {},
                currentForm:"Dealer",
                modalName: ""
            }
        },
        computed: {
            loading(){
                return this.$store.getters.getDealerLoading
            },
            
        },
        components:{
            BreadCrumb, Form, Users, Addresses, Modals
        },
        methods:{
           /* Modalı açan event */
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalProps.parent_id = this.$store.getters.companyId.data
                    this.modalName = modal
                }
            },
            /* Componentlerin içerisinden hangi modalın açıldığı ile ilgili event  */
            pageSettings: function(state, form){
                this.newButton = state
                this.currentForm = form
            },
            onComplete: function(isLastStep){
                if(isLastStep){
                    this.$router.push('/Dealer/List')
                }
            },
            changeStep: async function(prevIndex, nextIndex){
                switch(prevIndex){
                    case 0:
                        return this.$refs.GeneralForm.$refs.Form.validate().then( async success =>{
                            if(success){
                                let data = prepareRequestData(this.GeneralForms, this.$refs.GeneralForm.formData)
                                await this.$store.dispatch('company_add', data)
                                if(this.$store.getters.getCompanyStatus.status == "Success"){
                                    this.newButton = true
                                    this.currentForm = "CompanyAddresses"
                                    await this.$store.dispatch('companyaddresses_get', {parent_id: this.$store.getters.companyId && this.$store.getters.companyId.data} )
                                    return true
                                }else{
                                    return false
                                }
                            }else {
                                return false
                            }
                        })  
                        break
                    case 1:
                        this.newButton = true
                        this.currentForm = "CompanyUser"
                        await this.$store.dispatch('companyuser_get', {parent_id: this.$store.getters.companyId && this.$store.getters.companyId.data} )
                        return true
                    case 2:
                        return false
                    default:
                        return false
                }
            }
        }
    }
</script>
<style lang="css" scoped > 
    @import "./styles/add.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Dealer/Add.vue